import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';
import { RouteStore } from 'bernie-core';

import { HotelViewModel } from 'models';

import { BreakfastAndWifiDisclaimer } from './breakfast-wifi-disclaimer';
import { ListingDescription } from './listing-description';
import { LoyaltyMessage } from './loyalty-message';
import { Messaging } from 'components/common/messaging';
import { SearchResultsReviews } from './search-results-reviews';

interface ListingCommonSectionProps {
  model: HotelViewModel;
  routeStore: RouteStore;
  routeStoreGoBack: () => void;
}

export const ListingCommonSection: React.FC<ListingCommonSectionProps> = ({ model, routeStore, routeStoreGoBack }) => {
  const { disclaimerDialog, hotelDescription, primaryCardMessages, primaryCardMessagingModel, reviews, hotelId, loyaltyEarnAwards } = model;

  const { loyaltyBaseEarnMessage, loyaltyBaseEarnAccessibilityMessage, loyaltyEarnIcon } = { ...loyaltyEarnAwards };

  return (
    <>
      <ErrorBoundary label="hotel.search.listing.messaging">
        <Messaging
          className="listing__messaging uitk-grid uitk-type-300"
          primaryMessaging={primaryCardMessagingModel}
          primaryMessagingList={primaryCardMessages}
        />
      </ErrorBoundary>
      <LoyaltyMessage
        loyaltyEarnIcon={loyaltyEarnIcon}
        loyaltyBaseEarnAccessibilityMessage={loyaltyBaseEarnAccessibilityMessage}
        loyaltyBaseEarnMessage={loyaltyBaseEarnMessage}
      />
      <BreakfastAndWifiDisclaimer
        disclaimerDialog={disclaimerDialog}
        handleBack={routeStoreGoBack}
        hotelId={hotelId}
        routeStore={routeStore}
      />
      <ListingDescription description={hotelDescription} />
      <ErrorBoundary label="hotel.search.listing.reviews">
        <SearchResultsReviews className="listing__reviews all-t-margin-two" reviews={reviews} />
      </ErrorBoundary>
    </>
  );
};
